__turbopack_context__.v({
  "btnLabel": "K0ldFG_btnLabel",
  "buttonFocused": "K0ldFG_buttonFocused",
  "closeBtn": "K0ldFG_closeBtn",
  "closeBtnWrapper": "K0ldFG_closeBtnWrapper",
  "drawerWrapper": "K0ldFG_drawerWrapper",
  "myDrawerStyle": "K0ldFG_myDrawerStyle",
  "openBtn": "K0ldFG_openBtn",
});
